import { z } from 'zod';

/**
 * 選択範囲の情報を表す型
 */
export interface SavedSelection {
  /** 選択範囲の開始位置（文字オフセット） */
  start: number;
  /** 選択範囲の終了位置（文字オフセット） */
  end: number;
  /** 選択開始のDOMノード */
  startContainer?: Node;
  /** 選択開始のオフセット */
  startOffset?: number;
  /** 選択終了のDOMノード */
  endContainer?: Node;
  /** 選択終了のオフセット */
  endOffset?: number;
}

/**
 * 選択範囲の情報のZodスキーマ
 */
export const SavedSelectionSchema = z.object({
  start: z.number(),
  end: z.number(),
  startContainer: z.instanceof(Node).optional(),
  startOffset: z.number().optional(),
  endContainer: z.instanceof(Node).optional(),
  endOffset: z.number().optional(),
}); 